// import { NOTIFICATION_STANDARD_DURATION } from '../conf/notifications';

export enum NotificationLevel {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}
// Support type to declare dictionaries
type EnumDictionary<T extends string | symbol | number, U> = {
  [K in T]: U;
};
// Icons dictionary
const NOTIFICATION_ICON: EnumDictionary<NotificationLevel, string> = {
  [NotificationLevel.Info]: 'pi cm-info',
  [NotificationLevel.Success]: 'pi cm-check',
  [NotificationLevel.Warning]: 'pi cm-alert',
  [NotificationLevel.Error]: 'pi cm-cancel',
};
// Colors dictionary
const NOTIFICATION_COLOR: EnumDictionary<NotificationLevel, string> = {
  [NotificationLevel.Info]: 'text-blue-700',
  [NotificationLevel.Success]: 'text-green-700',
  [NotificationLevel.Warning]: 'text-yellow-700',
  [NotificationLevel.Error]: 'text-red-700',
};
// BackgroundColors dictionary
const NOTIFICATION_BGCOLOR: EnumDictionary<NotificationLevel, string> = {
  [NotificationLevel.Info]: 'bg-blue-100',
  [NotificationLevel.Success]: 'bg-green-100',
  [NotificationLevel.Warning]: 'bg-yellow-100',
  [NotificationLevel.Error]: 'bg-red-100',
};

export class Notification {
  level = NotificationLevel.Info;
  summary = '';
  message = '';
  icon = '';
  color = '';
  background_color = '';
  route?: string = undefined;
  // duration = NOTIFICATION_STANDARD_DURATION;

  constructor(summary: string, message: string, level = NotificationLevel.Info, route?: string) {
    this.summary = summary;
    this.message = message;
    this.level = level;
    if(route)
      this.route = route;
    else
      this.route = undefined;
    this.icon = NOTIFICATION_ICON[level];
    this.color = NOTIFICATION_COLOR[level];
    this.background_color = NOTIFICATION_BGCOLOR[level];
  }
}
